import React, { useState, useContext, createContext } from "react";
import { SearchModal } from "../components/modals/SearchModal";

const SearchContext = createContext();
const SearchToggleContext = createContext();

export function useSearch() {
    return useContext(SearchContext);
}

export function useSearchToggle() {
    return useContext(SearchToggleContext);
}

export default function SearchProvider({ children }) {
    const [showSearchModal, setShowSearchModal] = useState(false);
    const toggleSearchModal = () => setShowSearchModal((prev) => !prev);

    return (
        <SearchContext.Provider value={showSearchModal}>
            <SearchToggleContext.Provider value={toggleSearchModal}>
                {children}
                {showSearchModal && <SearchModal />}
            </SearchToggleContext.Provider>
        </SearchContext.Provider>
    );
}
